module.exports = __webpack_public_path__ + "1744a4502efe927d7cdbb7fca1b29e52.pdf";